// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3NOny","header":"ClearentDisclaimer_header__2EKT-","inner":"ClearentDisclaimer_inner__2GpeF"};